import React, { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router'
import GlobalContext from '../Components/GlobalContext'
import axios from 'axios'
import { useNavigate, useRevalidator } from 'react-router';

import { browserLocalPersistence, getAuth, setPersistence, signInWithCustomToken } from 'firebase/auth'
import { getDatabase, get, ref, set } from 'firebase/database';
import Loading from '../Components/Loading';
import { Card, Col, Container, Row } from 'react-bootstrap';
import LogoQualy from '../Components/LogoQualy';

function formatDateTime(date) {
    const pad = (n) => String(n).padStart(2, "0");

    date = new Date(date)

    const dd = pad(date.getDate());
    const mm = pad(date.getMonth() + 1);
    const yyyy = date.getFullYear();

    const hh = pad(date.getHours());
    const min = pad(date.getMinutes());
    const ss = pad(date.getSeconds());

    return `${dd}/${mm}/${yyyy} ${hh}:${min}:${ss}`;
}

function UnattendedLogin(props) {

    const { uaCode } = useParams()
    const { globalData } = useContext(GlobalContext)
    const navigate = useNavigate()

    const [accessAllowed, setAccessAllowed] = useState(null)
    const [revokedDatetime, setRevokedDatetime] = useState(null)

    const checkUserUnnatendedAccess = async () => {
        const path = '/unnatendedAccess/'

        const db = getDatabase()

        return get(ref(db, path)).then((snapshot) => {
            if (!snapshot.exists()) return false;

            const val = snapshot.val()
            for (const [company, uaData] of Object.entries(val)) {
                for (const [uid, status] of (Object.entries(uaData))) {
                    if (uid === uaCode) {
                        if (Object.keys(status).includes("revoked")) {
                            setRevokedDatetime(status["revoked"])
                            return false
                        } else {
                            set(ref(db, `/unnatendedAccess/${company}/${uaCode}/lastAccess`), new Date().toISOString())

                            return true
                        }
                    }
                }
            }
            return false
        })
    }

    const getAuthenticationToken = () => {
        const url = `${globalData.apiHost}/unattendedAccess`

        let data = JSON.stringify({
            "uaCode": uaCode
        });

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: url,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer @ydGYwUWMjvC4YVZH7%qYH%ki7Z^Q!A8omrK%E7YP8YzDKee@Eu4Zh!tVrt2TSW2'
            },
            data: data
        };


        axios.request(config)
            .then((response) => {
                const auth = getAuth(props.app)
                const token = response.data

                auth.signOut()



                setPersistence(auth, browserLocalPersistence).then(() => {
                    signInWithCustomToken(auth, token).then((userCredential) => {
                        document.cookie = `firebaseAuth=true; max-age=7200; path=/`;
                    }).then((a) => {
                        navigate('/')
                    })
                })
            })
            .catch((error) => {
                console.log(error);
            });

    }

    const AccessDeniedPage = () => {
        return <Container fluid className="vh-100 d-flex justify-content-center align-items-center">
            <Row>
                <Col>
                    <Card className="text-center p-4 shadow">
                        <Card.Body>
                            <LogoQualy className="m-3" />
                            <Card.Title as="h3">Acesso negado</Card.Title>
                            <Card.Text>Este acesso foi revogado em: {formatDateTime(revokedDatetime)}</Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    }

    useEffect(() => {
        checkUserUnnatendedAccess().then((allowed) => {
            if (allowed) {
                getAuthenticationToken()
            } else {
                setAccessAllowed(false)
            }
        })
    }, [])


    if (accessAllowed === null) {
        return <Loading />
    }

    if (accessAllowed === false) {
        return <AccessDeniedPage />
    }

}

export default UnattendedLogin